/**
 * Reine Hilfsfunktionen für den NutriChat (UX-Audit Phase 5).
 * Kein React, keine Seiteneffekte — damit unit-testbar und in Hook
 * wie Component gleichermaßen nutzbar.
 */

/** Bytes menschenlesbar: "1.4 KB", "2.3 MB". */
export function fmtBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

/** Tageszeit-abhängige Begrüßung. */
export function getTimeGreeting(): string {
  const h = new Date().getHours();
  if (h < 12) return 'Guten Morgen';
  if (h < 18) return 'Guten Tag';
  return 'Guten Abend';
}

/** Die Eröffnungsnachricht des Assistenten — eine Stelle, zwei Aufrufer. */
export function initialGreeting(assistantName: string): string {
  return `${getTimeGreeting()}! Ich bin ${assistantName}, Ihr KI-Dokumentationsassistent. Was kann ich heute für Sie tun?`;
}

/**
 * Heuristische Dokumentkategorie aus dem Freitext der Nachricht.
 * Reicht für die Vorbelegung — der Nutzer kann sie in der Akte ändern.
 */
export function detectCategory(text: string): string {
  const lower = text.toLowerCase();
  if (lower.includes('befund')) return 'Befund';
  if (lower.includes('rezept')) return 'Rezept';
  if (lower.includes('überweisung')) return 'Überweisung';
  if (lower.includes('laborwert') || lower.includes('labor')) return 'Laborwert';
  if (lower.includes('bericht')) return 'Bericht';
  return 'Sonstige';
}
